import React from "react";
import { Session } from "../requests";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

function SignInPage(props) {
  const { onSignIn } = props;

  const navigate = useNavigate();

  function handleSubmit(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const formData = new FormData(currentTarget);
    const params = {
      name: formData.get("name"),
      password: formData.get("password"),
    };

    Session.create(params).then((data) => {
      if (data.id) {
        onSignIn().then(() => {
          navigate("/clients");
        });
      }
    });
  }

  return (
    <main>
      <h1 className="title">Sign In</h1>

      <Form className="form" onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="name"
            name="name"
            id="name"
            placeholder="Enter name"
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            name="password"
            id="password"
            placeholder="Enter Password"
          />
        </Form.Group>
        <br />
        <Button variant="outline-primary" type="submit">
          Submit
        </Button>
      </Form>
    </main>
  );
}

export default SignInPage;
